
export default [
  {
    id: 'swallowed-grandma',
    title: 'Computer Swallowed Grandma',
    content: [
      `The computer swallowed grandma.`,
      `Yes, honestly its true!`,
      `She pressed ‘control’ and ‘enter’`,
      `And disappeared from view.`,
      ``,
      `It devoured her completely,`,
      `The thought just makes me squirm.`,
      `She must have caught a virus`,
      `Or been eaten by a worm.`,
      ``,
      `I’ve searched through the recycle bin`,
      `And files of every kind;`,
      `I’ve even used the Internet,`,
      `But nothing did I find.`,
      ``,
      `In desperation, I asked Jeeves`,
      `My searches to refine.`,
      `The reply from him was negative,`,
      `Not a thing was found ‘online.’`,
      ``,
      `So, if inside your ‘Inbox, ’`,
      `My Grandma you should see,`,
      `Please ‘Copy, ’ ‘Scan’ and ‘Paste’ her`,
      `In an email back to me.`,
    ]
  },
  {
    id: 'ducks',
    title: '3 White Ducks',
    content: [
      `Three ducks pecked around`,
      `In a garden one warm day`,
      `They wore beautiful coats`,
      `Of white feathers to display`,
      `They primped and they pampered`,
      ``,
      `These coats of pure white`,
      `Their strutting and flapping`,
      `Created quite a sight`,
      `It was a lovely summer day`,
      `And they adored the warm sun`,
      ``,
      `Just three little ducks`,
      `Searching for a bit of fun `,
      `But it grew hotter and hotter`,
      `Oh dear, it was warm`,
      `If they didn't find water`,
      `Could it do them some harm?`,
      ``,
      `They might find a stream`,
      `Or a small pond would do`,
      `But when they could find none`,
      `They started to stew`,
      ``,
      `Finally they came across`,
      `A child's small pool`,
      `They plopped in immediately`,
      `Their mom raised no fool`,
      ``,
      `So my friend, please remember`,
      `If you feel something's amok`,
      `At your child's wading pool`,
      `You may find 3 white ducks!`,
    ],
  },
  {
    id: 'my-computer',
    title: 'My Computer',
    content: [
      `My computer has a language`,
      `That is foreign to me`,
      `It speaks of RAM and Gigabytes`,
      `And what could ROM be!`,
      ``,
      `I don't understand the Windows`,
      `My computer says are there`,
      `Nor the Gem Clip at the side of my page`,
      `Wth eyes that blink and stare!`,
      ``,
      `I don't unerstand the cures`,
      `That maintenance wizards do`,
      `It's called defragmenter, span disk,`,
      `And virus cleaning too!`,
      ``,
      `Yet, computer and I work hand and eye`,
      `With a mouse to translate`,
      `The tasks that I want it to do`,
      `While it points out my mistakes!`,
    ]
  },
  {
    id: 'clowns',
    title: 'Class Clown',
    content: [
      `hello reader, i'm trying too hard`,
      `as if you could grade me`,
      `for every thought I discard`,
      `here - please dissect my ramblings`,
      `into coherent readings`,
      ``,
      `clumsily crafting my feelings, i’m scrambling`,
      `mending my thoughts digestible for you`,
      `i just wanted a good poem,`,
      `but i guess this pathetic afterthought will do`,
      `similar to the class toad`,
      `sprawling my consciousness out`,
      `a beating heart exposed`
    ],
  },
  {
    id: 'binary',
    title: 'There are 10 types of people in this world that can understand this poem',
    content: [
      '101110101101‬',
      '‭1011111011101111‬',
      '‭1111111011101101‬',
      '‭1010‬',
      '‭10111­0101101‬',
      '‭1111101011001110‬'
    ],
  },
  {
    id: 'conditions',
    title: 'Conditions Of Programming',
    content: [
      `If you want to wear those shoes,`,
      `Put them on.`,
      `There is no agreement of purposes,`,
      `In the first place.`,
      `You will do as you wish.`,
      `And I know this!`,
      ``,
      `If you want to declare you are right,`,
      `When wrong stares me in the face.`,
      `And you want me to believe,`,
      `What you perceive.`,
      `Do it!`,
      ``,
      `There is no argument.`,
      `Whatever you choose to do from now on...`,
      `That is up to you.`,
      `Conditions of programming,`,
      `Have been accepted as they are!`,
      ``,
      `You see things as you wish them to exist.`,
      `And I choose to refrain from becoming a conformist.`,
      `However...`,
      ``,
      `Let's come to admit,`,
      `We are both in conflict...`,
      `With the current nonsense that is being dished!`,
      ``,
      `And getting out of it provides neither one of us an exit!`,
    ],
  },
  {
    id: 'javascript',
    title: 'JavaScript',
    content: [
      `when we first met we were really broke`,
      `you got back into code & it was no joke`,
      `Your career took off & they flew us to cool places`,
      `met many people, lots of smiling faces`,
      `O’Reilly book deal, is this really real?`,
      ``,
      `not long ago we skipped many meals`,
      `soft skills, coding skills, ready go`,
      `everybody knows it’s who and what you know`,
      ``,
      `If you think I’m dumb for loving JavaScript`,
      `you better listen up and you better get hip`,
      `don’t waste your hate on me, I’m helping refugees,`,
      `homeless coders and talented mentees.`,
      `newbies, seniors, mid-levels alike`,
      ``,
      `Gang of Four, Crockford & Brendan Eich`,
      `Put us all together & it’s a motley crew`,
      `what we have in common is what we all knew…`,
      `code can change your life`
    ],
  },
  {
    id: 'exercise',
    title: 'Exercise',
    content: [
      `When I think about exercise,`,
      `I'm inspired to join a gym class,`,
      `Then after taking a short rest,`,
      `That feeling from me seems to pass.`,
      ``,
      `When looking into the mirror,`,
      `To exercise I should make a start,`,
      `But thinking about it at my age,`,
      `It could be bad for my heart.`,
      ``,
      `My teenagers need to exercise,`,
      `Run at least a mile each day,`,
      `Then at the end of two weeks,`,
      `They'd be fourteen miles away!`,
      ``,
      `An aerobics class may be fun,`,
      `Moving to music, properly trained,`,
      `But I heard reports of those classes,`,
      `How often an ankle is sprained.`,
      ``,
      `Having seen others at the gym,`,
      `How they puff, grunt and perspire,`,
      `Agony written over their faces,`,
      `Leaves me free from any desire.`,
      ``,
      `I'm happy for others to exercise,`,
      `So long as it doesn't include me,`,
      `I'd rather relax with my feet up,`,
      `While watching sports on TV.`,
    ]
  },
  {
    id: 'bake',
    title: 'I Like To Bake',
    content: [
      `Lord, you know I like to bake,`,
      `That velvety rich chocolate cake,`,
      `Covered with icing, I never stop`,
      `Until chocolate curls adorn the top.`,
      ``,
      `Lord, you know I like to bake,`,
      `Custard slices and biscuits make,`,
      `With fruit, nuts and choc.chips,`,
      `Though they all linger on my hips`,
      ``,
      `Lord, you know I like to bake,`,
      `(I say it's for my family's sake),`,
      `Apple pies and cheesecake too,`,
      `And dumplings in the Irish stew.`,
      ``,
      `Lord, you know I like to bake,`,
      `But I need to curb my intake,`,
      `Pavlova, a delicious sugary fluff,`,
      `I never seem to have enough.`,
      ``,
      `Lord, you know I like to bake,`,
      `But cholesterol pills I now take,`,
      `These words I must never utter,`,
      `"Please pass me the cream and butter"`,
      ``,
      `Lord, a special favour I shall ask,`,
      `It would only be a simple task,`,
      `You who changed water into wine,`,
      `Dissolve those calories when I dine!`,
    ]
  },
  {
    id: 'low-tech',
    title: 'Low-Tech Computing',
    content: [
      `My new computer's quite the gift`,
      `And one I truly covet -`,
      `With all the latest features`,
      `Who could help but love it`,
      ``,
      `I'll surf the net at breakneck speed`,
      `As if I'm in a race`,
      `There is no end to what I'll do`,
      `Launched in cyberspace`,
      ``,
      `My new computer's quite the joy`,
      `I'ii savor dusk till dawn`,
      `Now all I need to find is`,
      `The switch that turns it on!`,
    ]
  }
]
